export default class AppButton {
  isLoadingSuccess(val) {
    return val
      ? "button is-success is-small is-loading"
      : "button is-small is-success";
  }

  isLoadingInfo(val) {
    return val
      ? "button is-info is-small is-loading"
      : "button is-small is-info";
  }

  isLoadingInfoOutlined(val) {
    return val
      ? "button is-info is-small is-loading is-outlined"
      : "button is-small is-info is-outlined";
  }

  isLoadingInfoInverted(val) {
    return val
      ? "button is-info is-small is-loading is-inverted"
      : "button is-small is-info is-inverted";
  }

  isLoadingDefault(val) {
    return val ? "button is-small is-loading" : "button is-small";
  }

  isLoadingDanger(val) {
    return val
      ? "button is-danger is-small is-loading"
      : "button is-small is-danger";
  }

  isLoadingDangerInverted(val) {
    return val
      ? "button is-danger is-inverted is-small is-loading"
      : "button is-small is-inverted is-danger";
  }
}
